import { FormGroup, ValidatorFn, FormControl, FormArray } from "@angular/forms";

/**
 * Custom validator functions for reactive form validation
 */
export class ConfirmeValidators {
  /**
   * Validates that child controls in the form group are equal
   */
  static childrenEqual: ValidatorFn = (formGroup: FormGroup) => {
    const [firstControlName, ...otherControlNames] = Object.keys(
      formGroup.controls || {}
    );
    const isValid = otherControlNames.every(
      (controlName) =>
        formGroup.get(controlName).value ===
        formGroup.get(firstControlName).value
    );
    return isValid ? null : { childrenNotEqual: true };
  };

  static inputValidator: ValidatorFn = (formGroup: FormGroup) => {
    const [firstControlName, secondControlName, thirdControlName] = Object.keys(
      formGroup.controls || {}
    );
    const isValid =
      (formGroup.get(firstControlName).value &&
        formGroup.get(firstControlName).value.length > 0) ||
      (formGroup.get(secondControlName).value &&
        formGroup.get(secondControlName).value.length > 0) ||
      (formGroup.get(thirdControlName).value &&
        formGroup.get(thirdControlName).value.length > 0) ||
      false;
    return isValid ? null : { inputNotValidator: true };
  };
  static emailValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      // tslint:disable-next-line:max-line-length
      const isValid = control.value.match(
        /[a-zA-Z0-9c]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/
      );
      return isValid ? null : { emailNotValidator: true };
    }
    return null;
  };
  static usernameValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      // tslint:disable-next-line:max-line-length
      const isValid = control.value.match(
        /^[a-zA-Z0-9+_.@-]+(\.[a-zA-Z0-9+_.@-]*){0,1}$/g
      );
      return isValid ? null : { usernameNotValidator: true };
    }
    return null;
  };
  static numberOnlyValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(/^[0-9]+(\[0-9]*){0,1}$/g);
      return isValid ? null : { numberNotValidator: true };
    }
    return null;
  };
  static numberValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(/^[0-9]+(\.[0-9]*){0,1}$/g);
      return isValid ? null : { numberNotValidator: true };
    }
    return null;
  };
  static numberNegativeValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(/^[-]?[0-9]+(\.[0-9]*){0,1}$/g);
      return isValid ? null : { numberNotValidator: true };
    }
    return null;
  };
  static numberDecimalValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(/^[0-9]+(\,[0-9]*){0,2}$/g);
      return isValid ? null : { numberNotValidator: true };
    }
    return null;
  };
  static numberDecimalOnlyValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(/^[0-9]+(\.[0-9]*){0,1}$/g);
      return isValid ? null : { numberNotValidator: true };
    }
    return null;
  };
  static passwordValidator: ValidatorFn = (control: FormControl) => {
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!*?&-+.,()_])([A-Za-z\d$@$!*?&]|[^ ]){8,20}$/
      );
      return isValid ? null : { passwordNotValidator: true };
    }
    return { passwordNotValidator: true };
  };
  static passwordValidatorNulleable: ValidatorFn = (control: FormControl) => {
    if (control.value == null || control.value == '') {
      return null;
    }
    if (control.value && control.value.length > 0) {
      const isValid = control.value.match(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!*?&-+.,()_])([A-Za-z\d$@$!*?&]|[^ ]){8,20}$/
      );
      return isValid ? null : { passwordNotValidator: true };
    }
    return { passwordNotValidator: true };
  };
  static minSelectedCheckboxes: ValidatorFn = (array: FormArray) => {
    const totalSelected = array.controls
      // get a list of checkbox values (boolean)
      .map((control) => control.value)
      // total up the number of checked checkboxes
      .reduce((prev, next) => (next ? prev + next : prev), 0);

    // if the total is not greater than the minimum, return the error message
    return totalSelected >= 1 ? null : { required: true };
  };

  static maxSelectedCheckboxes(cantidad: number) {
    return (array: FormArray) => {
      const totalSelected = array.controls
        // get a list of checkbox values (boolean)
        .map((control) => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected <= cantidad ? null : { required: true };
    };
  }

  static minSelectedCheckboxes2(cantidad: number) {
    return (array: FormArray) => {
      const totalSelected = array.controls
        // get a list of checkbox values (boolean)
        .map((control) => control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected >= cantidad ? null : { required: true };
    };
  }

  static maxSelectedCheckboxesConRespuestaAdicional(cantidad: number) {
    return (array: FormArray) => {
      const totalSelected = array.controls
        // get a list of checkbox values (boolean)
        .map((control, index) => typeof control.value == "object" ? control.value[index] : control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected <= cantidad ? null : { required: true };
    };
  }

  static minSelectedCheckboxesConRespuestaAdicional(cantidad: number) {
    return (array: FormArray) => {
      const totalSelected = array.controls
        // get a list of checkbox values (boolean)
        .map((control, index) => typeof control.value == "object" ? control.value[index] : control.value)
        // total up the number of checked checkboxes
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      // if the total is not greater than the minimum, return the error message
      return totalSelected >= cantidad ? null : { required: true };
    };
  }

  static validacionVacia: ValidatorFn = (control: FormControl) => {
    return null;
  }

  static childrenNumberMaximo: ValidatorFn = (formGroup: FormGroup) => {
    const [firstControlName, ...otherControlNames] = Object.keys(
      formGroup.controls || {}
    );

    const isValid = otherControlNames.every(
      (controlName) => {
        const firstControlValue = formGroup.get(firstControlName).value;
        const secondControlValue = formGroup.get(controlName).value;
        if (!firstControlValue || !secondControlValue) {
          return true;
        }

        const isValid1 = firstControlValue.toString().match(/^[0-9]+(\.[0-9]*){0,1}$/g);

        const isValid2 = secondControlValue.toString().match(/^[0-9]+(\.[0-9]*){0,1}$/g);
        return (isValid1 && isValid2 && Number.parseInt(isValid1[0]) <= Number.parseInt(isValid2[0]));
      }
    );
    return isValid ? null : { childrenNotEqual: true };
  };

  static noWhitespace: ValidatorFn = (control: FormControl) => {
    const valor = (control.value?.toString() ?? '') as string;
    const isValid = valor.length > 0 && valor.match(/^\s*$/) !== null;
    return !isValid ? null : { 'whitespace': true }
  }

  static mustMatchFieldValidator(field: string): ValidatorFn {
    return (control: FormControl) => {
      const field1 = control.parent.get(field)?.value;
      const field2 = control.value;

      return field1 === field2 ? null : { 'mustMatchField': true };
    }
  }
}
